import AbstractRequestTask from "../AbstractRequestTask";
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';
import Launcher from '../../apa/Launcher';

class loginByTokenTask extends AbstractRequestTask {
    constructor(params) {
        super();
        this.statusCode404As200 = true;
    }

    getHeaders() {
        return {};
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        //TODO: Change version path and see the diferences between v1 and v2, v2 sends a push error
        //params missing user_session & paymentmethods, that's why push_session sends an error.
        return `${http}${url}/services/user/v2/loginbytoken`;
    }

    getParams() {
        const params = super.getParams();
        delete params.user_token;
        const token = DeviceStorage.getItem('CMR_Experience_Token') || '';
        const extra_params = { token };
        //* Enviar token como parametro
        console.log('[loginByToken params]:: ', params);
        console.log('[loginByToken token]:: ', token);
        delete params.HKS;
        delete params.api_version;
        delete params.format;

        return { ...params, ...extra_params };
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }

    isValid(data) {
        console.log('[loginbyToken V1 isValid]:: ', data);
        if (data.errors || !data.data || data.data === 'errors') {
            return false;
        }

        return true;
    }
}

export default loginByTokenTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/LoginByTokenTask.js